import Vue from 'vue';

export default Vue.directive('meditable', {
    bind: function (el, binding) {
        // Make sure expression provided is a function
        if(binding.value) {
            /**
             * set content editable default value
             */
            if(binding.value?.defaultValue) el.innerHTML = binding.value.defaultValue;
        }
    }
})